import { selectSafeAuthenticatedUser } from '../store/auth/authSlice'
import { useAppSelector } from '../store/hooks'

export const useAuthenticatedUser = () => useAppSelector(selectSafeAuthenticatedUser)
